import { render, staticRenderFns } from "./SoundRightsRecordSelector.vue?vue&type=template&id=430bf6a2&scoped=true"
import script from "./SoundRightsRecordSelector.vue?vue&type=script&lang=js"
export * from "./SoundRightsRecordSelector.vue?vue&type=script&lang=js"
import style0 from "./SoundRightsRecordSelector.vue?vue&type=style&index=0&id=430bf6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430bf6a2",
  null
  
)

export default component.exports